module.exports = __webpack_public_path__ + "img/13-4.ad4cce9b.jpg";